import apiRoutes from '../constants/apiRoutes';
import baseApi from '../services/api';
import { AccessTemplateType, AccessTemplateTypeListItem, UserPayload } from './company';
import { ApiResponse } from './types/common';

const userList = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<any, any>({
      query: ({
        pageNumber,
        pageSize,
        search,
        sort,
        sortOrder,
        role,
        internalUserAccessTemplateType,
        userStatus,
      }) => {
        let baseEndpoint = `${apiRoutes.allUsers}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if (search) {
          baseEndpoint += `&search=${search}`;
        }
        if (sort) {
          baseEndpoint += `&sort=${sort}&sortOrder=${sortOrder || 'ASC'}`;
        }
        if (role) {
          baseEndpoint += `&role=${role}`;
        }
        if (internalUserAccessTemplateType) {
          baseEndpoint += `&access=${internalUserAccessTemplateType}`;
        }
        if (userStatus) {
          baseEndpoint += `&userStatus=${userStatus}`;
        }
        return baseEndpoint;
      },
    }),
    getUsersSummary: builder.query<any, any>({
      query: ({ pageNumber, pageSize, search, sort, sortOrder }) => {
        let baseEndpoint = `${apiRoutes.users}/summary?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if (search) {
          baseEndpoint += `&search=${search}`;
        }
        if (sort) {
          baseEndpoint += `&sort=${sort}&sortOrder=${sortOrder || 'ASC'}`;
        }

        return baseEndpoint;
      },
    }),
    getUserById: builder.query<any, string>({
      query: (id) => apiRoutes.userDetailsbyId(id),
    }),
    inviteUser: builder.mutation<any, any>({
      query: (payload: UserPayload) => ({
        url: `${apiRoutes.users}`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['userList'],
    }),
    updateUser: builder.mutation<any, any>({
      query: (payload: UserPayload) => ({
        url: `${apiRoutes.users}/${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['userList'],
    }),
    deleteUser: builder.mutation<any, any>({
      query: (payload: { id: string }) => ({
        url: `${apiRoutes.users}/${payload.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['userList'],
    }),
    retryCreateUser: builder.mutation<any, any>({
      query: (payload: { id: string }) => ({
        url: `${apiRoutes.users}/${payload.id}`,
        method: 'POST',
      }),
      invalidatesTags: ['userList'],
    }),
    getDealSources: builder.query<any, any>({
      query: () => apiRoutes.dealSources,
    }),
    getAccessTemplateTypes: builder.query<ApiResponse<AccessTemplateType[]>, void>({
      query: () => apiRoutes.internalAccessTemplateTypes,
    }),
    getAccessTemplateTypesList: builder.query<ApiResponse<AccessTemplateTypeListItem[]>, void>({
      query: () => apiRoutes.internalAccessTemplateTypesList,
    }),
  }),
});

export const {
  useLazyGetUsersQuery,
  useLazyGetUsersSummaryQuery,
  useInviteUserMutation,
  useLazyGetUserByIdQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useRetryCreateUserMutation,
  useLazyGetDealSourcesQuery,
  useGetAccessTemplateTypesQuery,
  useLazyGetAccessTemplateTypesListQuery,
} = userList;
